import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
    public faqs: any[] = [
        {
            "headingId": "headingFaq1",
            "collapseId": "collapseFaq1",
            "title": "faqs.faq1.title",
            "answer": "faqs.faq1.answer",
            "expanded": "true",
            "class": "show"
        },
        {
            "headingId": "headingFaq2",
            "collapseId": "collapseFaq2",
            "title": "faqs.faq2.title",
            "answer": "faqs.faq2.answer",
            "expanded": "false",
            "class": ""
        },
        {
            "headingId": "headingFaq3",
            "collapseId": "collapseFaq3",
            "title": "faqs.faq3.title",
            "answer": "faqs.faq3.answer",
            "expanded": "false",
            "class": ""
        },
        {
            "headingId": "headingFaq4",
            "collapseId": "collapseFaq4",
            "title": "faqs.faq4.title",
            "answer": "faqs.faq4.answer",
            "expanded": "false",
            "class": ""
        },
        {
            "headingId": "headingFaq5",
            "collapseId": "collapseFaq5",
            "title": "faqs.faq5.title",
            "answer": "faqs.faq5.answer",
            "expanded": "false",
            "class": ""
        },
        {
            "headingId": "headingFaq6",
            "collapseId": "collapseFaq6",
            "title": "faqs.faq6.title",
            "answer": "faqs.faq6.answer",
            "expanded": "false",
            "class": ""
        },
        {
            "headingId": "headingFaq7",
            "collapseId": "collapseFaq7",
            "title": "faqs.faq7.title",
            "answer": "faqs.faq7.answer",
            "expanded": "false",
            "class": ""
        },
        {
            "headingId": "headingFaq8",
            "collapseId": "collapseFaq8",
            "title": "faqs.faq8.title",
            "answer": "faqs.faq8.answer",
            "expanded": "false",
            "class": ""
        }
    ]
    constructor() { }

    ngOnInit() {
    }

}
